// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: #F5F2E7;
}

/* header{
    position: fixed;
    background-color: #F5F2E7 !important;
    z-index: 2;
    width: 100%;
} */

/* navbar */
h3.navbar-brand {
    Color: rgba(107, 142, 118, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 20px;
}

h6.nav-date {
    color: rgba(107, 142, 118, 1);
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    text-align: center;
}

a.navbar-brand {
    color: rgba(107, 142, 118, 1);
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    text-align: left;
}

.NavbarNotificationImage img {
    width: 50px;
    /* margin-right: 10px; */
    height: 30px;
    margin-left: 17%;
}


/* navbar endd */

.Sidebar {
    width: 200px !important;
    background: #fff;
    /* min-height: 100vh; */
    /* box-shadow: 1px 1px 10px rgb(0 0 0 / 15%); */
    padding: 30px 20px;
    /* height: 100%; */
}

.Sidebar ul {
    padding: 0;
}

.Sidebar ul li {
    /* padding: 10px 0; */
}

/* Sidebar link styling */
.Sidebar ul li a {
    color: #6B8E76;
    font-size: 16px;
    text-decoration: none;
    font-weight: 500;
    display: flex;
    align-items: center;
    width: 80%;
    padding: 10px;
    border-radius: 5px;
    transition: background-color 0.3s ease, color 0.3s ease;
}

.Sidebar .navbar-brand {
    margin-bottom: 40px;
    display: block;
}

.MainScreen {
    display: flex;
    width: 100% !important;
}

.Sidebar ul li img {
    height: 20px;
    width: 20px;
    margin-right: 11px;
    object-fit: contain;
}

.ProfileIcon img {
    height: 40px;
    width: 40px;
    cursor: pointer;
    border-radius: 50%;
    object-fit: cover;
}

.ProfileIcon {
    margin-left: 20px;
    position: relative;
}

.user-dropdown-menu {
    position: absolute;
    top: 50px;
    right: 0;
    z-index: 1000;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    width: 150px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-right: 10px;
}

.user-dropdown-menu ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.user-dropdown-menu li {
    padding: 10px;
    cursor: pointer;
}

.user-dropdown-menu li:hover {
    background-color: #f0f0f0;
}

.close-btn {
    border: none;
    background: none;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    position: absolute;
    right: 8px;
    top: -6px;
}

ul.dropdown-menu.show {
    position: absolute;
    right: 20px;
    width: 220px;
    left: auto;
}

.dropdown {
    position: static;
}

nav.navbar.navbar-expand-lg {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #fff;
    box-shadow: 1px 1px 10px rgb(0 0 0 / 1%);
}

@media(max-width:991px) {
    .Sidebar {
        position: fixed;
        z-index: 11;
    }

    /* Maintain same button size */
    button.btn.btn-secondary {
        color: var(--secondary-100, rgba(250, 238, 240, 1));
        border: 1px solid #ccc;
        background-color: var(--primary-300, rgba(228, 87, 135, 1));
        position: absolute;
        top: 0;
        right: 0;
        z-index: 11;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        border-radius: 5px;
    }

    /* Show the toggle button only for small screens */
    .toggle-button {
        display: block !important;
    }
}

/* Hover effect fixes */
.Sidebar ul li a:hover ,
.Sidebar ul li a.active{
    background-color: #6B8E76;
    color: white;
    margin-bottom: 2px;
}

/* Change image color to white */
.Sidebar ul li a:hover img,
.Sidebar ul li a.active img {
    filter: brightness(0) invert(1);
}

/* Media Query for small screens */
@media screen and (max-width: 700px) {
    /* Initially hide the sidebar */
    .Sidebar {
        transform: translateX(-250px);
    }

    /* Sidebar is shown when toggled */
    .Sidebar.toggled {
        transform: translateX(0);
    }
}
.profile-nav{
    border-bottom: 1px solid;
    border-color: #c8c3c3 !important;
    font-size: 1.25rem;
    font-weight: 600;
    padding-bottom: 11px !important;
    margin-bottom: 10px;
}
.setting-nav{
    border-bottom: 1px solid;
    border-color: #c8c3c3 !important;
    padding-bottom: 20px !important;
}

.logout-nav{
    font-size: 1.25rem;
    font-weight: 600;
}
.account-design{
    margin-left: 9px !important;
    margin-top: 4px !important;
}

.navback-button{
    background-color: transparent;
    border: none !important;
    cursor: pointer !important;
    display: flex;
    font-size: 18px;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/InsocialOrbit/Assets/css/layout.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;;;;;GAKG;;AAEH,WAAW;AACX;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;AACpB;;;AAGA,gBAAgB;;AAEhB;IACI,uBAAuB;IACvB,gBAAgB;IAChB,uBAAuB;IACvB,+CAA+C;IAC/C,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,uDAAuD;AAC3D;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI;QACI,eAAe;QACf,WAAW;IACf;;IAEA,8BAA8B;IAC9B;QACI,mDAAmD;QACnD,sBAAsB;QACtB,2DAA2D;QAC3D,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,WAAW;QACX,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,kBAAkB;IACtB;;IAEA,kDAAkD;IAClD;QACI,yBAAyB;IAC7B;AACJ;;AAEA,uBAAuB;AACvB;;IAEI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;;IAEI,+BAA+B;AACnC;;AAEA,kCAAkC;AAClC;IACI,+BAA+B;IAC/B;QACI,6BAA6B;IACjC;;IAEA,kCAAkC;IAClC;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;AACvB;AACA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB","sourcesContent":["body {\n    background-color: #F5F2E7;\n}\n\n/* header{\n    position: fixed;\n    background-color: #F5F2E7 !important;\n    z-index: 2;\n    width: 100%;\n} */\n\n/* navbar */\nh3.navbar-brand {\n    Color: rgba(107, 142, 118, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    font-size: 20px;\n}\n\nh6.nav-date {\n    color: rgba(107, 142, 118, 1);\n    font-family: 'Poppins', sans-serif;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 30px;\n    text-align: center;\n}\n\na.navbar-brand {\n    color: rgba(107, 142, 118, 1);\n    font-family: 'Poppins', sans-serif;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 30px;\n    text-align: left;\n}\n\n.NavbarNotificationImage img {\n    width: 50px;\n    /* margin-right: 10px; */\n    height: 30px;\n    margin-left: 17%;\n}\n\n\n/* navbar endd */\n\n.Sidebar {\n    width: 200px !important;\n    background: #fff;\n    /* min-height: 100vh; */\n    /* box-shadow: 1px 1px 10px rgb(0 0 0 / 15%); */\n    padding: 30px 20px;\n    /* height: 100%; */\n}\n\n.Sidebar ul {\n    padding: 0;\n}\n\n.Sidebar ul li {\n    /* padding: 10px 0; */\n}\n\n/* Sidebar link styling */\n.Sidebar ul li a {\n    color: #6B8E76;\n    font-size: 16px;\n    text-decoration: none;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    width: 80%;\n    padding: 10px;\n    border-radius: 5px;\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.Sidebar .navbar-brand {\n    margin-bottom: 40px;\n    display: block;\n}\n\n.MainScreen {\n    display: flex;\n    width: 100% !important;\n}\n\n.Sidebar ul li img {\n    height: 20px;\n    width: 20px;\n    margin-right: 11px;\n    object-fit: contain;\n}\n\n.ProfileIcon img {\n    height: 40px;\n    width: 40px;\n    cursor: pointer;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.ProfileIcon {\n    margin-left: 20px;\n    position: relative;\n}\n\n.user-dropdown-menu {\n    position: absolute;\n    top: 50px;\n    right: 0;\n    z-index: 1000;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    width: 150px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    margin-right: 10px;\n}\n\n.user-dropdown-menu ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.user-dropdown-menu li {\n    padding: 10px;\n    cursor: pointer;\n}\n\n.user-dropdown-menu li:hover {\n    background-color: #f0f0f0;\n}\n\n.close-btn {\n    border: none;\n    background: none;\n    font-size: 24px;\n    font-weight: bold;\n    cursor: pointer;\n    position: absolute;\n    right: 8px;\n    top: -6px;\n}\n\nul.dropdown-menu.show {\n    position: absolute;\n    right: 20px;\n    width: 220px;\n    left: auto;\n}\n\n.dropdown {\n    position: static;\n}\n\nnav.navbar.navbar-expand-lg {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background: #fff;\n    box-shadow: 1px 1px 10px rgb(0 0 0 / 1%);\n}\n\n@media(max-width:991px) {\n    .Sidebar {\n        position: fixed;\n        z-index: 11;\n    }\n\n    /* Maintain same button size */\n    button.btn.btn-secondary {\n        color: var(--secondary-100, rgba(250, 238, 240, 1));\n        border: 1px solid #ccc;\n        background-color: var(--primary-300, rgba(228, 87, 135, 1));\n        position: absolute;\n        top: 0;\n        right: 0;\n        z-index: 11;\n        width: 50px;\n        height: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 18px;\n        border-radius: 5px;\n    }\n\n    /* Show the toggle button only for small screens */\n    .toggle-button {\n        display: block !important;\n    }\n}\n\n/* Hover effect fixes */\n.Sidebar ul li a:hover ,\n.Sidebar ul li a.active{\n    background-color: #6B8E76;\n    color: white;\n    margin-bottom: 2px;\n}\n\n/* Change image color to white */\n.Sidebar ul li a:hover img,\n.Sidebar ul li a.active img {\n    filter: brightness(0) invert(1);\n}\n\n/* Media Query for small screens */\n@media screen and (max-width: 700px) {\n    /* Initially hide the sidebar */\n    .Sidebar {\n        transform: translateX(-250px);\n    }\n\n    /* Sidebar is shown when toggled */\n    .Sidebar.toggled {\n        transform: translateX(0);\n    }\n}\n.profile-nav{\n    border-bottom: 1px solid;\n    border-color: #c8c3c3 !important;\n    font-size: 1.25rem;\n    font-weight: 600;\n    padding-bottom: 11px !important;\n    margin-bottom: 10px;\n}\n.setting-nav{\n    border-bottom: 1px solid;\n    border-color: #c8c3c3 !important;\n    padding-bottom: 20px !important;\n}\n\n.logout-nav{\n    font-size: 1.25rem;\n    font-weight: 600;\n}\n.account-design{\n    margin-left: 9px !important;\n    margin-top: 4px !important;\n}\n\n.navback-button{\n    background-color: transparent;\n    border: none !important;\n    cursor: pointer !important;\n    display: flex;\n    font-size: 18px;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
